/** Open Buddy's tour (e.g. from onboarding "Give me a tour"). */
export const BUDDY_TOUR_EVENT = 'klax-buddy-tour';

export const BUDDY_TOUR_TOTAL_STEPS = 4;

export type BuddyTourStep = {
  titleKey: string;
  bodyKey: string;
  okayKey: string;
  closeKey: string;
  step: number;
  target: string;
};

/** Tour steps use UILM keys; resolve with t() in BuddyTourCard. */
export const BUDDY_TOUR: BuddyTourStep[] = [
  {
    titleKey: 'BUDDY_TOUR_CONVERSATION_TITLE',
    bodyKey: 'BUDDY_TOUR_STEP1_BODY',
    okayKey: 'BUDDY_TOUR_OKAY',
    closeKey: 'BUDDY_TOUR_CLOSE',
    step: 1,
    target: 'choose-agent',
  },
  {
    titleKey: 'BUDDY_TOUR_GROUP_TITLE',
    bodyKey: 'BUDDY_TOUR_STEP2_BODY',
    okayKey: 'BUDDY_TOUR_OKAY',
    closeKey: 'BUDDY_TOUR_CLOSE',
    step: 2,
    target: 'agents-group',
  },
  {
    titleKey: 'BUDDY_TOUR_QUICK_ACTIONS_TITLE',
    bodyKey: 'BUDDY_TOUR_STEP3_BODY',
    okayKey: 'BUDDY_TOUR_OKAY',
    closeKey: 'BUDDY_TOUR_CLOSE',
    step: 3,
    target: 'quick-actions',
  },
  {
    titleKey: 'BUDDY_TOUR_MESSAGE_TITLE',
    bodyKey: 'BUDDY_TOUR_STEP4_BODY',
    okayKey: 'BUDDY_TOUR_OKAY',
    closeKey: 'BUDDY_TOUR_CLOSE',
    step: 4,
    target: 'composer',
  },
];

export function findBuddyTourTarget(target: string) {
  return document.querySelector(`[data-buddy-tour-target="${target}"]`);
}

/** First step whose target is on the page, from `fromIndex` onward. */
export function nextVisibleBuddyTourIndex(fromIndex = 0) {
  return BUDDY_TOUR.findIndex(
    (step, index) => index >= fromIndex && Boolean(findBuddyTourTarget(step.target)),
  );
}

/**
 * Tour start index. -1 until the sidebar Buddy row is on the page so the
 * tour cannot open on the ⋯ menu or Quick Actions while chat is still mounting.
 */
export function firstBuddyTourIndex() {
  if (!findBuddyTourTarget('choose-agent')) {
    return -1;
  }
  return nextVisibleBuddyTourIndex(0);
}
